import styled from '@emotion/styled';
import { Box } from '~Styles';
import { Row } from '../sharedStyles';

export * from '../sharedStyles';

export const PaymentRow = styled(Row)`
  justify-content: space-between;
`;

export const PaymentBlock = styled.div`
  flex-grow: 1;
  flex-basis: 0;
`;

export const CardDetailsWrapper = styled(Box)`
  padding: 12px 16px;
  border-radius: 4px;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
`;

export const CardDetailsHeader = styled.h3`
  margin: 0 0 4px;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 0.5px;
`;

export const CardDetail = styled.div`
  font-size: 14px;
  font-family: monospace;
  font-weight: normal;
`;
